export const storeUserData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getuserdata",
      payload: data,
    });
  };
};

export const searchInputValue = (data) => {
  return (dispatch) => {
    dispatch({
      type: "searchinputvalue",
      payload: data,
    });
  };
};

export const getAutoSuggestionData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getautosuggestion",
      payload: data,
    });
  };
};

export const toggleAISwitch = (data) => {
  return (dispatch) => {
    dispatch({
      type: "toggleAISwitch",
      payload: data,
    });
  };
};

export const updateQuestionUuidForSearch = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateSelectedQuestionUuid",
      payload: data,
    });
  };
};

export const updateDomainData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "selectDomain",
      payload: data,
    });
  };
};

export const updateSearchData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateSearchData",
      payload: data,
    });
  };
};

export const updateSearchData2 = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateSearchDataWithRating",
      payload: data,
    });
  };
};

export const searchDataLoading = (data) => {
  return (dispatch) => {
    dispatch({
      type: "searchloadingstart",
      payload: data,
    });
  };
};

export const getExpertProfilePics = (data) => {
  return (dispatch) => {
    dispatch({
      type: "searchexpertProfilePicData",
      payload: data,
    });
  };
};

export const fetchratings = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getAnswerRating",
      payload: data,
    });
  };
};

export const addSearchedAnswerUuidInList = (data, docdata) => {
  return (dispatch) => {
    dispatch({
      type: "updateAnswerUuidList",
      payload: { answerid: data, docid: docdata },
    });
  };
};

export const advanceFilterModalToggle = (data) => {
  return (dispatch) => {
    dispatch({
      type: "toggleAFModal",
      payload: data,
    });
  };
};

export const saveTopicUuid = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateTopicUuid",
      payload: data,
    });
  };
};

export const getSelectedQuestion = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateSelectedQuestion",
      payload: data,
    });
  };
};

export const getSelectedAnswer = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateSelectedAnswer",
      payload: data,
    });
  };
};

export const showNoShowConfetti = (data) => {
  return (dispatch) => {
    dispatch({
      type: "toggleConfetti",
      payload: data,
    });
  };
};

export const filteringSearchData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "filteredSearchData",
      payload: data,
    });
  };
};

export const getSearchHistoryTotalCount = (data) => {
  return (dispatch) => {
    dispatch({
      type: "historydataTotalCount",
      payload: data,
    });
  };
};
export const historySearchData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "historydata",
      payload: data,
    });
  };
};

export const updatePageNumberHistory = (data) => {
  return (dispatch) => {
    dispatch({
      type: "loadmorepages",
      payload: data,
    });
  };
};

export const getSearchHistorySortFilterVal = (data) => {
  return (dispatch) => {
    dispatch({
      type: "historydataSortFilter",
      payload: data,
    });
  };
};

export const searchDocSourceFilterUpdate = (data) => {
  return (dispatch) => {
    dispatch({
      type: "datasourcefilter",
      payload: data,
    });
  };
};

export const getAllNotifis = (data) => {
  return (dispatch) => {
    dispatch({
      type: "allnotifications",
      payload: data,
    });
  };
};

export const newWebSocketRecieved = (data) => {
  return (dispatch) => {
    dispatch({
      type: "newWebsocketMessage",
      payload: data,
    });
  };
};

export const updateAskTheTeamStatus = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateIsShowAskTheTeamButton",
      payload: data,
    });
  };
};

export const recommendData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "recommendPageData",
      payload: data,
    });
  };
};
export const getTrendingDataLoadingStatus = (data) => {
  return (dispatch) => {
    dispatch({
      type: "trendingdataloading",
      payload: data,
    });
  };
};

export const domainFilterChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "domainFilterChange",
      payload: data,
    });
  };
};
export const notificationsDataRecommend = (data) => {
  return (dispatch) => {
    dispatch({
      type: "notificationactiondata",
      payload: data,
    });
  };
};

export const getInlineImages = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getinlineimages",
      payload: data,
    });
  };
};

export const getSearchSuggestionKeytag = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSearchSuggestionKeytag",
      payload: data,
    });
  };
};
// getSearchSuggestionKeytag
export const getExpertRecordKeyTag = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getExpertRecordKeyTag",
      payload: data,
    });
  };
};

export const getKeyTagExpert = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getKeyTagExpert",
      payload: data,
    });
  };
};

export const getNotifFavData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "notificationfavouritedata",
      payload: data,
    });
  };
};

export const notificationDataLoading = (data) => {
  return (dispatch) => {
    dispatch({
      type: "notificationdataloading",
      payload: data,
    });
  };
};

export const attachmentData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "attachmentsdata",
      payload: data,
    });
  };
};
export const getTrendingQA = (data) => {
  return (dispatch) => {
    dispatch({
      type: "trendingData",
      payload: data,
    });
  };
};
export const updateInlineImagesData = (list, data) => {
  return (dispatch) => {
    dispatch({
      type: "inlineimagesData",
      payload: {
        list: list,
        data: data,
      },
    });
  };
};

export const profilePagePictureData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "fetchprofilepicpageseeker",
      payload: data,
    });
  };
};

export const reloadHistoryPage = (list, data) => {
  return (dispatch) => {
    dispatch({
      type: "reloadHistoryPage",
      payload: {
        list: list,
        data: data,
      },
    });
  };
};

export const trendingDatatotalCount = (data) => {
  return (dispatch) => {
    dispatch({
      type: "trendingDataTotalCount",
      payload: data,
    });
  };
};

export const trendingDataSelectDomains = (data) => {
  return (dispatch) => {
    dispatch({
      type: "trendingDataSelectedDomain",
      payload: data,
    });
  };
};

export const trendingDataSelectSortingFilter = (data) => {
  return (dispatch) => {
    dispatch({
      type: "trendingDataSelectedSortingfilter",
      payload: data,
    });
  };
};

export const trendingDataSelectPageNo = (data) => {
  return (dispatch) => {
    dispatch({
      type: "trendingDataPageUpdate",
      payload: data,
    });
  };
};

export const forcefullyemptydata = (data) => {
  return (dispatch) => {
    dispatch({
      type: "forcefullyemptydata",
      payload: data,
    });
  };
};

export const refreshTrendingData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "refreshTrendingData",
      payload: data,
    });
  };
};

export const UpdatedTrendingData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateTrendingData",
      payload: data,
    });
  };
};

export const reloadTrendingData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "reloadTrendingPage",
      payload: data,
    });
  };
};

export const getUserBadgesSeekerData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "seekerAwardsData",
      payload: data,
    });
  };
};

export const getSeekerAwardsLoaderStatus = (data) => {
  return (dispatch) => {
    dispatch({
      type: "seekerAwardsLoader",
      payload: data,
    });
  };
};

export const openQuestionsData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "openquestionsdata",
      payload: data,
    });
  };
};

export const openQuestionsCount = (data) => {
  return (dispatch) => {
    dispatch({
      type: "openquestionscount",
      payload: data,
    });
  };
};

export const getTabSearchOpenQuestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateOpentabSearchValue",
      payload: data,
    });
  };
};

export const filterDomainDataOpenTab = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updatedomainsopentab",
      payload: data,
    });
  };
};

export const openQuestionsDataLoading = (data) => {
  return (dispatch) => {
    dispatch({
      type: "openquestionsloading",
      payload: data,
    });
  };
};

export const openQuestionsDelete = (data) => {
  return (dispatch) => {
    dispatch({
      type: "deleteopenquestions",
      payload: data,
    });
  };
};

export const deleteSelectedQuestion = (data) => {
  return (dispatch) => {
    dispatch({
      type: "deleteselectedquestion",
      payload: data,
    });
  };
};

export const getQuestionText = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getquestiontext",
      payload: data,
    });
  };
};

export const updateOpenTabData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateopentabdata",
      payload: data,
    });
  };
};

export const deleteSelectedOpenQuestionUuid = (data) => {
  return (dispatch) => {
    dispatch({
      type: "deleteselectedquestionUuid",
      payload: data,
    });
  };
};

export const updateSortOrderData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updatesortorderdata",
      payload: data,
    });
  };
};

export const getSelectedQuestionUuidWatchlist = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getselectedquestionUuidwatchlist",
      payload: data,
    });
  };
};

export const updatePageNumberOpenTab = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updatepagenumberopentab",
      payload: data,
    });
  };
};

export const updateSortFilterType = (data) => {
  return (dispatch) => {
    dispatch({
      type: "openquestionssortfilter",
      payload: data,
    });
  };
};

export const openQuestionDataObjectTyoe = (data) => {
  return (dispatch) => {
    dispatch({
      type: "selectedquestiondatainopentab",
      payload: data,
    });
  };
};

export const addRelevance = (data) => {
  return (dispatch) => {
    dispatch({
      type: "addrelevance",
      payload: data,
    });
  };
};

export const sortFilterDefault = (data) => {
  return (dispatch) => {
    dispatch({
      type: "sortfiltervalueadd",
      payload: data,
    });
  };
};

export const reloadOpenPageData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "reloadOpenPage",
      payload: data,
    });
  };
};

export const sortChangeOpenPage = (data) => {
  return (dispatch) => {
    dispatch({
      type: "sortChangeOpenPage",
      payload: data,
    });
  };
};

export const updatesortOpenOption = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updatesortOpenOption",
      payload: data,
    });
  };
};
export const answerUuidSentToUpdateViewCount = (data) => {
  return (dispatch) => {
    dispatch({
      type: "answerUuidSentToUpdateViewCount",
      payload: data,
    });
  };
};

export const allScrolledAnswerUuid = (data) => {
  return (dispatch) => {
    dispatch({
      type: "AllScrolledAnswerUuid",
      payload: data,
    });
  };
};

export const isBackClickedOnRecommend = (data) => {
  return (dispatch) => {
    dispatch({
      type: "isBackRecommend",
      payload: data,
    });
  };
};

export const preservePreviousRecommendData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "preservePrevData",
      payload: data,
    });
  };
};

export const trendingSearchQuery = (data) => {
  return (dispatch) => {
    dispatch({
      type: "trendingSearchQuery",
      payload: data,
    });
  };
};

export const updateAnsweredSearchedQuery = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateAnsweredSearchedQuery",
      payload: data,
    });
  };
};

export const updateAnsweredDomainValue = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateAnsweredDomainValue",
      payload: data,
    });
  };
};

export const updateAnsweredSortFilterValue = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateAnsweredSortFilterValue",
      payload: data,
    });
  };
};

export const reloadAnsweredtab = () => {
  return (dispatch) => {
    dispatch({
      type: "reloadAnsweredtab",
      payload: Math.random() * 10,
    });
  };
};

export const IsLoadingAnsweredtab = (data) => {
  return (dispatch) => {
    dispatch({
      type: "IsLoadingAnsweredtab",
      payload: data,
    });
  };
};

export const updateAnsweredTabData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateAnsweredTabData",
      payload: data,
    });
  };
};

export const updateFavouriteSearchedQuery = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateFavouriteSearchedQuery",
      payload: data,
    });
  };
};

export const updateFavouriteDomainValue = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateFavouriteDomainValue",
      payload: data,
    });
  };
};

export const updateFavouriteSortFilterValue = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateFavouriteSortFilterValue",
      payload: data,
    });
  };
};

export const reloadFavouritetab = () => {
  return (dispatch) => {
    dispatch({
      type: "reloadFavouritetab",
      payload: Math.random() * 10,
    });
  };
};

export const IsLoadingFavouritetab = (data) => {
  return (dispatch) => {
    dispatch({
      type: "IsLoadingFavouritetab",
      payload: data,
    });
  };
};

export const updateFavouriteTabData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateFavouriteTabData",
      payload: data,
    });
  };
};

export const updateSharedBySearchedQuery = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateSharedBySearchedQuery",
      payload: data,
    });
  };
};

export const updateSharedWithSearchedQuery = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateSharedWithSearchedQuery",
      payload: data,
    });
  };
};

export const updateSharedByDomainValue = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateSharedByDomainValue",
      payload: data,
    });
  };
};

export const updateSharedWithDomainValue = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateSharedWithDomainValue",
      payload: data,
    });
  };
};

export const updateSharedBySortFilterValue = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateSharedBySortFilterValue",
      payload: data,
    });
  };
};

export const updateSharedWithSortFilterValue = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateSharedWithSortFilterValue",
      payload: data,
    });
  };
};

export const reloadSharedBytab = () => {
  return (dispatch) => {
    dispatch({
      type: "reloadSharedBytab",
      payload: Math.random() * 10,
    });
  };
};

export const reloadSharedWithtab = () => {
  return (dispatch) => {
    dispatch({
      type: "reloadSharedWithtab",
      payload: Math.random() * 10,
    });
  };
};

export const IsLoadingSharedBytab = (data) => {
  return (dispatch) => {
    dispatch({
      type: "IsLoadingSharedBytab",
      payload: data,
    });
  };
};

export const IsLoadingSharedWithtab = (data) => {
  return (dispatch) => {
    dispatch({
      type: "IsLoadingSharedWithtab",
      payload: data,
    });
  };
};

export const updateSharedByTabData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateSharedByTabData",
      payload: data,
    });
  };
};

export const updateSharedWithTabData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateSharedWithTabData",
      payload: data,
    });
  };
};

export const updatePageNoAnswered = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updatePageNoAnswered",
      payload: data,
    });
  };
};
export const updatePageNoFavourite = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updatePageNoFavourite",
      payload: data,
    });
  };
};
export const updatePageNoSharedBy = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updatePageNoSharedBy",
      payload: data,
    });
  };
};

export const updatePageNoSharedWith = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updatePageNoSharedWith",
      payload: data,
    });
  };
};

export const getkeyTagPayload = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getkeyTagPayload",
      payload: data,
    });
  };
};

export const getKeyTagsData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getKeyTagsData",
      payload: data,
    });
  };
};

export const KeyTagsDataIsLoading = (data) => {
  return (dispatch) => {
    dispatch({
      type: "KeyTagsDataIsLoading",
      payload: data,
    });
  };
};

export const KeyTagsDataSearchQuery = (data) => {
  return (dispatch) => {
    dispatch({
      type: "KeyTagsDataSearchQuery",
      payload: data,
    });
  };
};

export const KeyTagsDataPageNoUpdate = (data) => {
  return (dispatch) => {
    dispatch({
      type: "KeyTagsDataPageNoUpdate",
      payload: data,
    });
  };
};

export const KeyTagsDataSourceUpdate = (data) => {
  return (dispatch) => {
    dispatch({
      type: "KeyTagsDataSourceUpdate",
      payload: data,
    });
  };
};

export const keyTermDomainUpdate = (data) => {
  return (dispatch) => {
    dispatch({
      type: "keyTermDomainUpdate",
      payload: data,
    });
  };
};

export const keyTermSearchQueryUpdate = (data) => {
  return (dispatch) => {
    dispatch({
      type: "keyTermSearchQueryUpdate",
      payload: data,
    });
  };
};

export const keyTermDataUpdate = (data) => {
  return (dispatch) => {
    dispatch({
      type: "keyTermDataUpdate",
      payload: data,
    });
  };
};

export const keyTermDataIsLoading = (data) => {
  return (dispatch) => {
    dispatch({
      type: "keyTermDataIsLoading",
      payload: data,
    });
  };
};

export const keyTermDataPageNoUpdate = (data) => {
  return (dispatch) => {
    dispatch({
      type: "keyTermDataPageNoUpdate",
      payload: data,
    });
  };
};

export const updateKeyTagData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateKeyTagData",
      payload: data,
    });
  };
};

export const markedAnsweredData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "markedAnsweredData",
      payload: data,
    });
  };
};

export const markedTrendingData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "markedTrendingData",
      payload: data,
    });
  };
};

export const markedFavData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "markedFavData",
      payload: data,
    });
  };
};

export const markedSharedByData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "markedSharedByData",
      payload: data,
    });
  };
};

export const markedSharedWithData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "markedSharedWithData",
      payload: data,
    });
  };
};

export const keyTermWordsChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "keyTermWordsChange",
      payload: data,
    });
  };
};

export const keyTermWordsReload = (data) => {
  return (dispatch) => {
    dispatch({
      type: "keyTermWordsReload",
      payload: data,
    });
  };
};

export const allAnswerUuidEmptyForScrollCount = (data) => {
  return (dispatch) => {
    dispatch({
      type: "allAnswerUuidEmptyForScrollCount",
      payload: data,
    });
  };
};

export const getAllActivityData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getActivityData",
      payload: data,
    });
  };
};

export const getAIGenerativeData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateGenerativeAIText",
      payload: data,
    });
  };
};

export const getRefferedSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getrefferedSuggestions",
      payload: data,
    });
  };
};

export const captureAIGeneratedTextFromWebSocket = (data) => {
  return (dispatch) => {
    dispatch({
      type: "captureAIGeneratedTextFromWebSocket",
      payload: data,
    });
  };
};

export const UpdateGenerativeAITextWhenAPICall = (data) => {
  return (dispatch) => {
    dispatch({
      type: "UpdateGenerativeAITextWhenAPICall",
      payload: data,
    });
  };
};

/* Expert Actions start */
export const isDataLoadingExpertOpen = (data) => {
  return (dispatch) => {
    dispatch({
      type: "expertdataloading",
      payload: data,
    });
  };
};

export const updatePageNumberExpertOpenTab = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updatepagenumberexpertopentab",
      payload: data,
    });
  };
};
export const getIsOpenedQuestion = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getIsOpenedQuestion",
      payload: data,
    });
  };
};

export const getExpertOpenData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getexpertopenpagedata",
      payload: data,
    });
  };
};

export const getOpenDataCountExpert = (data) => {
  return (dispatch) => {
    dispatch({
      type: "openquestionscountexpert",
      payload: data,
    });
  };
};

export const ownRecordsValue = (data) => {
  return (dispatch) => {
    dispatch({
      type: "ownrecordsexpert",
      payload: data,
    });
  };
};

export const getDomainOfQuestion = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getselecteddomain",
      payload: data,
    });
  };
};

export const getSelectedQuestionDataExpert = (data) => {
  return (dispatch) => {
    dispatch({
      type: "selectedquestion",
      payload: data,
    });
  };
};

export const getForceRerouteUsersStatus = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getforcererouteusers",
      payload: data,
    });
  };
};

export const getExpertRequestUuid = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getexpertrequestuuid",
      payload: data,
    });
  };
};

export const getAcknowledgeStatus = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getacknowledgestatus",
      payload: data,
    });
  };
};

export const getTabSearchInputForExpertOpen = (data) => {
  return (dispatch) => {
    dispatch({
      type: "tabsearchinputvalue",
      payload: data,
    });
  };
};

export const getDomainValuesInExpertOpen = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getdomainsforexpert",
      payload: data,
    });
  };
};

export const sortChangeExpertOpenPage = (data) => {
  return (dispatch) => {
    dispatch({
      type: "sortChangeExpertOpenPage",
      payload: data,
    });
  };
};

export const sortFilterDefaultExpert = (data) => {
  return (dispatch) => {
    dispatch({
      type: "sortfiltervalueaddexpert",
      payload: data,
    });
  };
};

export const addRelevanceInExpertOpen = (data) => {
  return (dispatch) => {
    dispatch({
      type: "addrelevanceexpertopen",
      payload: data,
    });
  };
};

export const updateSortOptionsExpertOpen = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updatesortexpertopenoption",
      payload: data,
    });
  };
};

export const refreshExpertOpenTabData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "refreshopenpagedata",
      payload: data,
    });
  };
};

export const getQuestionDeclineStatus = (data) => {
  return (dispatch) => {
    dispatch({
      type: "checkquestiondeclinestatus",
      payload: data,
    });
  };
};
/* Expert Actions end */

export const isTrendingLoadMore = (data) => {
  return (dispatch) => {
    dispatch({
      type: "isTrendingLoadMore",
      payload: data,
    });
  };
};

export const uploadFile = (pdfFile) => {
  return (dispatch) => {
    dispatch({
      type: "uploadFile",
      payload: pdfFile,
    });
  };
};

export const handlChangeJobId = (jobId) => {
  return (dispatch) => {
    dispatch({
      type: "changeJobId",
      payload: jobId,
    });
  };
};

export const selectType = (select) => {
  return (dispatch) => {
    dispatch({
      type: "selectType",
      payload: select,
    });
  };
};

export const handleChangeNameField = (names) => {
  return (dispatch) => {
    dispatch({
      type: "name",
      payload: names,
    });
  };
};

export const handleChangeLinkField = (link) => {
  return (dispatch) => {
    dispatch({
      type: "link",
      payload: link,
    });
  };
};

export const handleChangeUrl = (url) => {
  return (dispatch) => {
    dispatch({
      type: "urlChange",
      payload: url,
    });
  };
};

export const handleChangeFrequency = (frquency) => {
  return (dispatch) => {
    dispatch({
      type: "freqChange",
      payload: frquency,
    });
  };
};

export const handleResetState = (payload) => {
  return (dispatch) => {
    dispatch({
      type: "reset",
      payload: payload,
    });
  };
};

export const handleResponse = (resp) => {
  return (dispatch) => {
    dispatch({
      type: "response",
      payload: resp,
    });
  };
};

export const handleModal = (modal) => {
  return (dispatch) => {
    dispatch({
      type: "modal",
      payload: modal,
    });
  };
};
export const handleSoId = (soId) => {
  return (dispatch) => {
    dispatch({
      type: "soId",
      payload: soId,
    });
  };
};

export const handlePayload = (bool) => {
  return (dispatch) => {
    dispatch({
      type: "bool",
      payload: bool,
    });
  };
};

export const handleImageCheck = (check) => {
  return (dispatch) => {
    dispatch({
      type: "checkImage",
      payload: check,
    });
  };
};

export const handlePdfCheck = (check) => {
  return (dispatch) => {
    dispatch({
      type: "checkPdf",
      payload: check,
    });
  };
};

export const handleButton = (check) => {
  return (dispatch) => {
    dispatch({
      type: "showButton",
      payload: check,
    });
  };
};

export const handleLoadingSpinner = (loader) => {
  return (dispatch) => {
    dispatch({
      type: "loader",
      payload: loader,
    });
  };
};

export const handleSeekerInput = (seeker) => {
  return (dispatch) => {
    dispatch({
      type: "seeker",
      payload: seeker,
    });
  };
};
export const handleExpertInput = (expert) => {
  return (dispatch) => {
    dispatch({
      type: "expert",
      payload: expert,
    });
  };
};

export const handleChangeUrlValue = (Url) => {
  return (dispatch) => {
    dispatch({
      type: "urlValue",
      payload: Url,
    });
  };
};

export const getCategories = (categories) => {
  return (dispatch) => {
    dispatch({
      type: "categories",
      payload: categories,
    });
  };
};

export const handlePageRefresh = (payload) => {
  return (dispatch) => {
    dispatch({
      type: "Refresh",
      payload: payload,
    });
  };
};

export const categoriesId = (id) => {
  return (dispatch) => {
    dispatch({
      type: "categoriesId",
      payload: id,
    });
  };
};

export const initailPage = (val) => {
  return (dispatch) => {
    dispatch({
      type: "initialPage",
      payload: val,
    });
  };
};

export const getFrequencyList = (val) => {
  return (dispatch) => {
    dispatch({
      type: "frequencyList",
      payload: val,
    });
  };
};

export const fileUploadError = (val) => {
  return (dispatch) => {
    dispatch({
      type: "uploadFileError",
      payload: val,
    });
  };
};

export const handleDoubleInput = (val) => {
  return (dispatch) => {
    dispatch({
      type: "uploadFileTwice",
      payload: val,
    });
  };
};

export const handleResetCategories = (val) => {
  return (dispatch) => {
    dispatch({
      type: "handleResetCategories",
      payload: val,
    });
  };
};

export const handleResetSeeker = (val) => {
  return (dispatch) => {
    dispatch({
      type: "handleReserSeeker",
      payload: val,
    });
  };
};

export const handleReserExpert = (val) => {
  return (dispatch) => {
    dispatch({
      type: "handleReserExpert",
      payload: val,
    });
  };
};

export const FirstRender = (val) => {
  return (dispatch) => {
    dispatch({
      type: "FirstRender",
      payload: val,
    });
  };
};

export const enableMutliple = (val) => {
  return (dispatch) => {
    dispatch({
      type: "enableMutliple",
      payload: val,
    });
  };
};

export const expertAnsweredFilter = (data) => {
  return (dispatch) => {
    dispatch({
      type: "expertAnsweredFilter",
      payload: data,
    });
  };
};
export const expertAnsweredDomainFilter = (data) => {
  return (dispatch) => {
    dispatch({
      type: "expertAnsweredDomainFilter",
      payload: data,
    });
  };
};
export const expertAnsweredSortFilter = (data) => {
  return (dispatch) => {
    dispatch({
      type: "expertAnsweredSortFilter",
      payload: data,
    });
  };
};

export const expertAnsweredCurationFilter = (data) => {
  return (dispatch) => {
    dispatch({
      type: "expertAnsweredCurationFilter",
      payload: data,
    });
  };
};

export const questionDataForEditor = (data) => {
  return (dispatch) => {
    dispatch({
      type: "questionDataForEditor",
      payload: data,
    });
  };
};

export const expertRankData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getExpertRank",
      payload: data,
    });
  };
};

export const viewCountStatsData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getViewCountStatsData",
      payload: data,
    });
  };
};

export const slaComplianceData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSLAComplianceData",
      payload: data,
    });
  };
};

export const getExpertScoreData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getExpertScore",
      payload: data,
    });
  };
};

export const updateExpirationDateForEditor = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateExpirationDateForEditor",
      payload: data,
    });
  };
};

export const updateCheckBoxValForEditor = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateCheckBoxValForEditor",
      payload: data,
    });
  };
};

export const getAverageResponseTime = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getAvgResTime",
      payload: data,
    });
  };
};

export const updateAnswerTextForEditor = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateAnswerTextForEditor",
      payload: data,
    });
  };
};

export const getRecentRatingsData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getRecentRatings",
      payload: data,
    });
  };
};

export const updateButtonEnableForEditor = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateButtonEnableForEditor",
      payload: data,
    });
  };
};

export const getRecentRatingsQuestionText = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getQuestionText",
      payload: data,
    });
  };
};

export const updateSubmissionTypeForEditor = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateSubmissionTypeForEditor",
      payload: data,
    });
  };
};

export const getRecentRatingsAnswerText = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getAnswerText",
      payload: data,
    });
  };
};

export const resetStateForEditor = () => {
  return (dispatch) => {
    dispatch({
      type: "resetStateForEditor",
      payload: "",
    });
  };
};

export const getQuestionResponseData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getQuestionTextData",
      payload: data,
    });
  };
};

export const updateOwnRecordsForEditor = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateOwnRecordsForEditor",
      payload: data,
    });
  };
};
export const getBestQuestionsData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getBestRatingsData",
      payload: data,
    });
  };
};

export const getWorstQuestionsData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getWorstRatingsData",
      payload: data,
    });
  };
};

export const getBetterRatingsData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getBetterRatingsData",
      payload: data,
    });
  };
};

export const getDomainByExpertData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getDomainByExpertData",
      payload: data,
    });
  };
};

export const getRatingsByExpertData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getRatingsByGroupData",
      payload: data,
    });
  };
};

export const getTotalAnsweredTrendDataExpert = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getTotalAnsweredTrendData",
      payload: data,
    });
  };
};

export const expertCurationChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "expertCurationChange",
      payload: data,
    });
  };
};

export const expertDomainChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "expertDomainChange",
      payload: data,
    });
  };
};

export const getExpertScoreTrendData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getExpertScoreTrendDataExpertStats",
      payload: data,
    });
  };
};

export const getDataForSlaComplianceTrend = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSlaComplianceTrendData",
      payload: data,
    });
  };
};
export const getAttachments = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getAttachments",
      payload: data,
    });
  };
};
export const getDataForResponseTimeTrend = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getResponseTimeTrendData",
      payload: data,
    });
  };
};
export const clearCompareAttachments = () => {
  return {
    type: "CLEAR_COMPARE_ATTACHMENTS",
  };
};

export const loadingDataForMyStat = (data) => {
  return (dispatch) => {
    dispatch({
      type: "loadingDataExpertMyStat",
      payload: data,
    });
  };
};

export const stapledAnswer = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getstapledanswer",
      payload: data,
    });
  };
};

export const getSearchDataKnowledgeEntry = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getsearchdataforknowledgeEntry",
      payload: data,
    });
  };
};

export const loadingSearchSuggestionsKnowledgeQA = (data) => {
  return (dispatch) => {
    dispatch({
      type: "dataloadingsuggestions",
      payload: data,
    });
  };
};

export const emptyStateAfterClick = (data) => {
  return (dispatch) => {
    dispatch({
      type: "emptystateafterclick",
      payload: data,
    });
  };
};

export const updateAttachmentForEditor = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateAttachmentsForEditor",
      payload: data,
    });
  };
};

export const updateQuestiontextForEditor = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateQuestiontextForEditor",
      payload: data,
    });
  };
};

export const savePageNumberAnswer = (data) => {
  return (dispatch) => {
    dispatch({
      type: "savePageNumberAnswer",
      payload: data,
    });
  };
};
export const AnsweredPageBool = (data) => {
  return (dispatch) => {
    dispatch({
      type: "AnsweredPageBool",
      payload: data,
    });
  };
};

export const updateAnotherExpertAnsweredForEditor = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateAnotherExpertAnsweredForEditor",
      payload: data,
    });
  };
};

export const updateDeclinedAnsweredForEditor = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateDeclinedAnsweredForEditor",
      payload: data,
    });
  };
};

export const updateRatingBoolean = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateRatingBoolean",
      payload: data,
    });
  };
};
export const updateNewDeclinedLoader = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateNewDeclinedLoader",
      payload: data,
    });
  };
};

// updateRatingBoolean
export const getInlineImagesForBestRatings = (data) => {
  return (dispatch) => {
    dispatch({
      type: "inlineImagesData",
      payload: data,
    });
  };
};

export const UpdateGenerativeAITextWithDiffLang = (data) => {
  return (dispatch) => {
    dispatch({
      type: "UpdateGenerativeAITextWithDiffLang",
      payload: data,
    });
  };
};

export const getgdriveFrequecyData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getdataforgdrivefrequency",
      payload: data,
    });
  };
};

export const getgdriveDocumentsData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getgdrivedocs",
      payload: data,
    });
  };
};

export const isLoadingSharedCMData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "isloadingsharedcmdata",
      payload: data,
    });
  };
};

export const isDrawerOpen = (data) => {
  return (dispatch) => {
    dispatch({
      type: "isDrawerOpen",
      payload: data,
    });
  };
};

export const DrawerAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: "DrawerAction",
      payload: data,
    });
  };
};

export const DrawerPayload = (data) => {
  return (dispatch) => {
    dispatch({
      type: "DrawerPayload",
      payload: data,
    });
  };
};

export const DrawerPropData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "DrawerPropData",
      payload: data,
    });
  };
};

export const SearchSuggestionsDataCM = (data) => {
  return (dispatch) => {
    dispatch({
      type: "suggestionsData",
      payload: data,
    });
  };
};

export const searchSuggestionsDataCountCM = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSuggestionsCount",
      payload: data,
    });
  };
};
export const changeTransfered = (data) => {
  return (dispatch) => {
    dispatch({
      type: "changeTransfered",
      payload: data,
    });
  };
};
export const changeCurationStatus = (data) => {
  return (dispatch) => {
    dispatch({
      type: "changeCurationStatus",
      payload: data,
    });
  };
};

export const updatePageNoInSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updatePageNoSearchSuggestions",
      payload: data,
    });
  };
};

export const getLoadingStatusForSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "loadingStatusForSearchSuggestions",
      payload: data,
    });
  };
};

export const deleteQuestionInSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getQuestionUuidForSearchSuggestions",
      payload: data,
    });
  };
};

export const getSourceFilterInSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSourceTypeForSearchFilter",
      payload: data,
    });
  };
};

export const getSourceFilterForDomains = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSourceTypeForDomainIds",
      payload: data,
    });
  };
};

export const getSourceFilterForFromDate = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSourceTypeForFromDate",
      payload: data,
    });
  };
};

export const getSourceFilterForTillDate = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSourceTypeForTillDate",
      payload: data,
    });
  };
};

export const updateRowsPerPage = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateRowsPerPage",
      payload: data,
    });
  };
};

export const getAcceptedQuestionFilter = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSourceTypeForAccepted",
      payload: data,
    });
  };
};

export const getSearchFilterForEmailFilter = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSourceTypeForEmail",
      payload: data,
    });
  };
};

export const searchSuggestionsDetails = (data) => {
  return (dispatch) => {
    dispatch({
      type: "searchSuggestionDetailsData",
      payload: data,
    });
  };
};

export const searchSuggestionsQuestionText = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getQuestionTextInSearchSuggestions",
      payload: data,
    });
  };
};

export const getSeekerNameInSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSeekerNameInSearchSuggestionsData",
      payload: data,
    });
  };
};

export const getUserTypeInSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getUserTypeInSearchSuggestions",
      payload: data,
    });
  };
};

export const getPostedDateInSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getPostedDateInSearchSuggestions",
      payload: data,
    });
  };
};

export const getTagsDataInSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getTagsInSuggestions",
      payload: data,
    });
  };
};

export const getRatingsDataInSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getRatingsInSearchSuggestions",
      payload: data,
    });
  };
};

export const resetRatingsData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "clearRatingsDataInSearchSuggestions",
      payload: data,
    });
  };
};

export const getGeoLevelIdInURL = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getGeoLevelId",
      payload: data,
    });
  };
};

export const getGeoLevelValueInURL = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getGeoLevelValue",
      payload: data,
    });
  };
};

export const getSeekerFilterInSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getFilterForSeekers",
      payload: data,
    });
  };
};

export const getSeekerFilterInfoInSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSeekerListInfo",
      payload: data,
    });
  };
};

export const getExpertFilterInSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getFilterForExperts",
      payload: data,
    });
  };
};

export const getExpertFilterInfoInSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getExpertListInfo",
      payload: data,
    });
  };
};

export const getDomainNameInSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getDomainNameInSearch",
      payload: data,
    });
  };
};

export const getAskedSourceForSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getAskedSourceInSearchSuggestions",
      payload: data,
    });
  };
};

export const clearExpertsOnClick = (data) => {
  return (dispatch) => {
    dispatch({
      type: "clearExpertsListData",
      payload: data,
    });
  };
};
export const getFolderNameForGDriveDocs = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getFolderName",
      payload: data,
    });
  };
};

export const getIdForGoogleDriveDocs = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getFolderId",
      payload: data,
    });
  };
};

export const getFrequencyNameForGoogleDrive = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getFrequencyName",
      payload: data,
    });
  };
};

export const cmRootRoutingData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmRootRoutingData",
      payload: data,
    });
  };
};

export const cmRootUpdateRoutingVal = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmRootUpdateRoutingVal",
      payload: data,
    });
  };
};

export const cmRootUpdateDomainVal = (data) => {
  // console.log("data",data)
  return (dispatch) => {
    dispatch({
      type: "cmRootUpdateDomainVal",
      payload: data,
    });
  };
};

export const cmRootGetCountryData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmRootGetCountryData",
      payload: data,
    });
  };
};

export const cmRootGetRegionData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmRootGetRegionData",
      payload: data,
    });
  };
};

export const cmRootUpdateRegionVal = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmRootUpdateRegionVal",
      payload: data,
    });
  };
};

export const cmRootUpdateCountryVal = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmRootUpdateCountryVal",
      payload: data,
    });
  };
};

export const checkIfComingBackSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "checkIfComingBack",
      payload: data,
    });
  };
};

export const getCheckForDeletedItems = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getCheckForDeletedItemsCM",
      payload: data,
    });
  };
};

export const getDeletedItemsInSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getDeletedItemsListInSearch",
      payload: data,
    });
  };
};

export const clearDeletedItemsInSearchArray = (data) => {
  return (dispatch) => {
    dispatch({
      type: "clearDeletedItemsFromArray",
      payload: data,
    });
  };
};

export const checkForDeleteAPICall = (data) => {
  return (dispatch) => {
    dispatch({
      type: "checkDeleteAPICall",
      payload: data,
    });
  };
};

export const definedRegionObj = (data) => {
  return (dispatch) => {
    dispatch({
      type: "definedRegionObj",
      payload: data,
    });
  };
};
export const ingestedSelectedData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "ingestedSelectedData",
      payload: data,
    });
  };
};

export const ingestedrefreshData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "ingestedrefreshData",
      payload: data,
    });
  };
};

export const domainAtomizerUpdate = (data) => {
  return (dispatch) => {
    dispatch({
      type: "domainAtomizerUpdate",
      payload: data,
    });
  };
};

export const cmrTotalCount = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrTotalCount",
      payload: data,
    });
  };
};
export const getExpertAnalyticsDataInCmOverview = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getviewsforoverviewexpert",
      payload: data,
    });
  };
};

export const getRatingsInExpertOverviewForCM = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getratingsbydatainexpertoverview",
      payload: data,
    });
  };
};

export const getRatingStarsInExpertOverviewCM = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getratingstarsdataforexpertoverview",
      payload: data,
    });
  };
};

export const getExpertsQCountsDataInOverview = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getexpertsqcountsdata",
      payload: data,
    });
  };
};

export const getCurationCountCMExpert = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getcurationcountcmexpert",
      payload: data,
    });
  };
};

export const getAuditLogsDataInCMOverviewSeeker = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getauditlogsdata",
      payload: data,
    });
  };
};

export const getActionValue = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getactionvalueandlabel",
      payload: data,
    });
  };
};

export const getDurationValue = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getdurationinmonths",
      payload: data,
    });
  };
};

export const getTotalCount = (data) => {
  return (dispatch) => {
    dispatch({
      type: "gettotalcount",
      payload: data,
    });
  };
};

export const getSourceValueInOverview = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getsourcevalue",
      payload: data,
    });
  };
};
export const isShowResultsCPR = (data) => {
  return (dispatch) => {
    dispatch({
      type: "isShowResultsCPR",
      payload: data,
    });
  };
};

export const cmrUpdatePageNo = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrUpdatePageNo",
      payload: data,
    });
  };
};
export const getQuestionCountData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getquestioncountdata",
      payload: data,
    });
  };
};

export const cmrUpdateData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrUpdateData",
      payload: data,
    });
  };
};
export const getDomainsTimelineData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getdomainstimelinedata",
      payload: data,
    });
  };
};

export const cmrUpdatePage = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrUpdatePage",
      payload: data,
    });
  };
};
export const getQuestionsCountByDayCount = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getquestionscountbyday",
      payload: data,
    });
  };
};

export const cmrRefreshPage = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrRefreshPage",
      payload: data,
    });
  };
};
export const cmOverViewTotalCountData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmOverViewTotalCountData",
      payload: data,
    });
  };
};

export const cmrTabSearchData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrTabSearchData",
      payload: data,
    });
  };
};
export const getDomainListCountInOverview = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getdomainslistcount",
      payload: data,
    });
  };
};
export const cmrUpdateFilters = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrUpdateFilters",
      payload: data,
    });
  };
};

export const getQuestionCountBreakdownData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getquestioncountbreakdown",
      payload: data,
    });
  };
};

export const cmrClickedData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrClickedData",
      payload: data,
    });
  };
};
export const getMonthsDurationInQuestionsSubmitted = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getmonthsvalueforquestionssubmitted",
      payload: data,
    });
  };
};
export const cmrIsGoBack = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrIsGoBack",
      payload: data,
    });
  };
};

export const cmrIsBackFromEmailLink = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrIsBackFromEmailLink",
      payload: data,
    });
  };
};

export const getMonthsDurationInAnsweredByVizerto = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getmonthsdurationforansweredbyvizerto",
      payload: data,
    });
  };
};

export const getMonthsDurationInTrendingSeach = (data) => {
  return (dispatch) => {
    dispatch({
      type: "gettrendingsearchdurationmonths",
      payload: data,
    });
  };
};

export const getDomainSpecificTimelineData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getdomainspecifictimelinedata",
      payload: data,
    });
  };
};

export const getSelectedUserTypeInOverview = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmOverViewSelectUser",
      payload: data,
    });
  };
};

export const SeekerUserTypeAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: "SeekerUserTypeAction",
      payload: data,
    });
  };
};

export const getDurationForMonthsForDomainSpecificGraph = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getdomainspecifictimeduration",
      payload: data,
    });
  };
};

export const getAverageAccuracyCount = (data) => {
  return (dispatch) => {
    dispatch({
      type: "averageaccuracycount",
      payload: data,
    });
  };
};

export const documentTypeAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: "documentTypeAction",
      payload: data,
    });
  };
};

export const cmrQuestionsFilter = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrQuestionsFilter",
      payload: data,
    });
  };
};
export const getExpertAnalyticsDataInCmOverviewForQuestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getexpertanalyticsforcmoverviewquestions",
      payload: data,
    });
  };
};

export const cmrExpertsList = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrExpertsList",
      payload: data,
    });
  };
};

export const cmrTimeFrameFilter = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrTimeFrameFilter",
      payload: data,
    });
  };
};

export const cmrAskFilter = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrAskFilter",
      payload: data,
    });
  };
};

export const cmrUsersFilter = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrUsersFilter",
      payload: data,
    });
  };
};

export const cmrSelectedDataDetailed = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrSelectedDataDetailed",
      payload: data,
    });
  };
};

export const cmrDetailedRefresh = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmrDetailedRefresh",
      payload: data,
    });
  };
};
export const cmOverViewSelectTab = (data) => {
  return (dispatch) => {
    dispatch({
      type: "cmOverViewSelectTab",
      payload: data,
    });
  };
};

export const crossnavigationAnswered = (data) => {
  return (dispatch) => {
    dispatch({
      type: "crossnavigationAnswered",
      payload: data,
    });
  };
};

export const filteredOrigSearchData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "filteredOrigSearchData",
      payload: data,
    });
  };
};

export const crossnavigationNotAnswered = (data) => {
  return (dispatch) => {
    dispatch({
      type: "crossnavigationNotAnswered",
      payload: data,
    });
  };
};

export const crossnavigationExpertCuration = (data) => {
  return (dispatch) => {
    dispatch({
      type: "crossnavigationExpertCuration",
      payload: data,
    });
  };
};
export const crossnavigationExpertCurationCurated = (data) => {
  return (dispatch) => {
    dispatch({
      type: "crossnavigationExpertCurationCurated",
      payload: data,
    });
  };
};

export const crossnavigationExpertDomain = (data) => {
  return (dispatch) => {
    dispatch({
      type: "crossnavigationExpertDomain",
      payload: data,
    });
  };
};

// getTabIndex
export const getTabIndex = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getTabIndex",
      payload: data,
    });
  };
};

export const getSlackTab = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSlackTab",
      payload: data,
    });
  };
};

export const setReload = (data) => {
  return (dispatch) => {
    dispatch({
      type: "setReload",
      payload: data,
    });
  };
};

// setReload

export const showEmptySuggestionsContent = (data) => {
  return (dispatch) => {
    dispatch({
      type: "showEmptySuggestions",
      payload: data,
    });
  };
};

export const getDislikesInSearchSuggestions = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getDislikesData",
      payload: data,
    });
  };
};

export const getDomainNameInSearchSuggestionsDetailPage = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getDomainNameInfo",
      payload: data,
    });
  };
};

export const getGenAiAnswerSummary = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getGenAISummary",
      payload: data,
    });
  };
};

export const getGenAIOverallRatingsData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "genAIOverallRatings",
      payload: data,
    });
  };
};

export const genAIAnswerToggleCM = (data) => {
  return (dispatch) => {
    dispatch({
      type: "genAIAnswerToggle",
      payload: data,
    });
  };
};

export const bestResultsToggleCM = (data) => {
  return (dispatch) => {
    dispatch({
      type: "bestResultsToggle",
      payload: data,
    });
  };
};

export const getQuestionsSubmittedData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "questionsSubmittedFilter",
      payload: data,
    });
  };
};

export const switchToggleGQA = (data) => {
  return (dispatch) => {
    dispatch({
      type: "switchToggleGQA",
      payload: data,
    });
  };
};

export const isLoadingGQA = (data) => {
  return (dispatch) => {
    dispatch({
      type: "isLoadingGQA",
      payload: data,
    });
  };
};

export const isSearchGQA = (data) => {
  return (dispatch) => {
    dispatch({
      type: "isSearchGQA",
      payload: data,
    });
  };
};

export const domainGQA = (data) => {
  return (dispatch) => {
    dispatch({
      type: "domainGQA",
      payload: data,
    });
  };
};

export const textGQA = (data) => {
  return (dispatch) => {
    dispatch({
      type: "textGQA",
      payload: data,
    });
  };
};

export const qaGQA = (data) => {
  return (dispatch) => {
    dispatch({
      type: "qaGQA",
      payload: data,
    });
  };
};
export const getdataMU = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getdataMU",
      payload: data,
    });
  };
};

export const updatePageNoMU = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updatePageNoMU",
      payload: data,
    });
  };
};

export const updatePageSizeMU = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updatePageSizeMU",
      payload: data,
    });
  };
};

export const tabSearchMU = (data) => {
  return (dispatch) => {
    dispatch({
      type: "tabSearchMU",
      payload: data,
    });
  };
};

export const sortOrderMU = (data) => {
  return (dispatch) => {
    dispatch({
      type: "sortOrderMU",
      payload: data,
    });
  };
};

export const sortFilterMU = (data) => {
  return (dispatch) => {
    dispatch({
      type: "sortFilterMU",
      payload: data,
    });
  };
};

export const reloadMU = () => {
  return (dispatch) => {
    dispatch({
      type: "reloadMU",
      payload: "",
    });
  };
};

export const drawerOpenMU = (data) => {
  return (dispatch) => {
    dispatch({
      type: "drawerOpenMU",
      payload: data,
    });
  };
};

export const selectedUserMU = (data) => {
  return (dispatch) => {
    dispatch({
      type: "selectedUserMU",
      payload: data,
    });
  };
};

export const adminSettingsGroupInfo = (data) => {
  return (dispatch) => {
    dispatch({
      type: "groupInfoData",
      payload: data,
    });
  };
};

export const adminSettingsRoutingLevels = (data) => {
  return (dispatch) => {
    dispatch({
      type: "routingLevelsData",
      payload: data,
    });
  };
};

export const toggleSettingsBox = (data) => {
  return (dispatch) => {
    dispatch({
      type: "toggleSettingsBox",
      payload: data,
    });
  };
};

export const getCurationRoutingValues = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getCurationRFoutingValuesAdmin",
      payload: data,
    });
  };
};

export const getCurationGroupValueAdmin = (data) => {
  return (dispatch) => {
    dispatch({
      type: "curationValueByGroups",
      payload: data,
    });
  };
};

export const getRawSearchData = (data) => {
  let newData = [];
  data.filter((obj) => {
    if (obj.confidence) {
      if (obj.suggestions.length > 0) {
        obj.suggestions.filter((obj2) => {
          newData.push(obj2);
        });
      } else {
        newData.push(obj);
      }
    }
  });
  return (dispatch) => {
    dispatch({
      type: "getRawSearchData",
      payload: newData,
    });
  };
};

export const sidebarOpenSP = (data) => {
  return (dispatch) => {
    dispatch({
      type: "sidebarOpenSP",
      payload: data,
    });
  };
};

export const regenerateTextSP = (data) => {
  return (dispatch) => {
    dispatch({
      type: "regenerateTextSP",
      payload: data,
    });
  };
};

export const selectedSourcesSP = (data) => {
  return (dispatch) => {
    dispatch({
      type: "selectedSourcesSP",
      payload: data,
    });
  };
};

export const updateLanguageSP = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateLanguageSP",
      payload: data,
    });
  };
};
export const updateSalesSummaryTypeSP = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateSalesSummaryTypeSP",
      payload: data,
    });
  };
};
export const updateShortCheckedTypeSP = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateShortCheckedTypeSP",
      payload: data,
    });
  };
};

export const updateDataMU = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateDataMU",
      payload: data,
    });
  };
};

export const updateroleListMU = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateroleListMU",
      payload: data,
    });
  };
};

export const updatefiltersDataMU = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updatefiltersDataMU",
      payload: data,
    });
  };
};

export const isLoadingAMU = (data) => {
  return (dispatch) => {
    dispatch({
      type: "isLoadingAMU",
      payload: data,
    });
  };
};
export const updatePageAMU = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updatePageAMU",
      payload: data,
    });
  };
};
export const updateStatus = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateStatus",
      payload: data,
    });
  };
};

export const updateStateValuesForSettingsAdmin = (key, value) => {
  return (dispatch) => {
    dispatch({
      type: "updateValues",
      payload: { key, value },
    });
  };
};

export const updateTabIndexKeyReroutingInterval = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateTabValForReroutingInterval",
      payload: data,
    });
  };
};

export const updateTabIndexForAbortPeriod = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateTabIndexValueAbortPeriod",
      payload: data,
    });
  };
};

export const updateTabIndexKeyExpertsAssigned = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateTabIndexForExpertsAssigned",
      payload: data,
    });
  };
};

export const isLoadingAdminData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "isLoadingAdmin",
      payload: data,
    });
  };
};
export const uploadFilesGQA = (data) => {
  return (dispatch) => {
    dispatch({
      type: "uploadFilesGQA",
      payload: data,
    });
  };
};

export const ActionLevel = (data) => {
  return (dispatch) => {
    dispatch({
      type: "ActionLevel",
      payload: data,
    });
  };
};

export const geoLevelRegionAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: "geoLevelRegionAction",
      payload: data,
    });
  };
};

export const selectRegionAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: "selectRegionAction",
      payload: data,
    });
  };
};

export const GetCountryValuesAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: "GetCountryValuesAction",
      payload: data,
    });
  };
};
export const SelectedCountryValueAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: "SelectedCountryValueAction",
      payload: data,
    });
  };
};

export const ActionRestrictionValue = (data) => {
  return (dispatch) => {
    dispatch({
      type: "ActionRestrictionValue",
      payload: data,
    });
  };
};
export const CountryActionBoolean = (data) => {
  return (dispatch) => {
    dispatch({
      type: "CountryActionBoolean",
      payload: data,
    });
  };
};

export const initialPageNoAMU = (data) => {
  return (dispatch) => {
    dispatch({
      type: "initialPageNoAMU",
      payload: data,
    });
  };
};

export const isRegeneratingGenAiText = (data) => {
  return (dispatch) => {
    dispatch({
      type: "isRegeneratingGenAiText",
      payload: data,
    });
  };
};

export const getDomainNameFromExpertOverview = (data) => {
  return (dispatch) => {
    dispatch({
      type: "selectedDomainNameFromExpertOverview",
      payload: data,
    });
  };
};

export const SearchExpDocData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "SearchExpDocData",
      payload: data,
    });
  };
};
export const getSeekerAttachment = (data) => {
  return (dispatch) => {
    dispatch({
      type: "seekerAttachmentData",
      payload: data,
    });
  };
};

export const seekerAnalyticsAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: "seekerAnalyticsAction",
      payload: data,
    });
  };
};

export const seekerSubmittedAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: "seekerSubmittedAction",
      payload: data,
    });
  };
};

export const changeGenerativeAITextWhenRegenerate = (data) => {
  return (dispatch) => {
    dispatch({
      type: "changeGenerativeAITextWhenRegenerate",
      payload: data,
    });
  };
};

export const getSeekerAttachmentsForTrending = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSeekerAttachmentsInTrending",
      payload: data,
    });
  };
};

export const getSeekerAttachmentsForAnswered = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSeekerAttachmentsInAnsweredTab",
      payload: data,
    });
  };
};

export const getSeekerAttachmentsForReccommend = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSeekerAttachmentsInReccommend",
      payload: data,
    });
  };
};

export const getSeekerAttachmentsForExpertRecords = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getSeekerAttachmentsInExpertRecords",
      payload: data,
    });
  };
};

export const getActionName = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getActionName",
      payload: data,
    });
  };
};
export const getIngestedEmailQuestion = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getIngestedEmailQuestion",
      payload: data,
    });
  };
};

export const getIngestedEmailAnswer = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getIngestedEmailAnswer",
      payload: data,
    });
  };
};
export const getEmailId = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getEmailId",
      payload: data,
    });
  };
};

export const getUpdatedSpinner = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getUpdatedSpinner",
      payload: data,
    });
  };
};

export const HPloading = (data) => {
  return (dispatch) => {
    dispatch({
      type: "HPloading",
      payload: data,
    });
  };
};

export const getIsRelevenceAT = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getIsRelevenceAT",
      payload: data,
    });
  };
};

export const updateSortFilterFT = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateSortFilterFT",
      payload: data,
    });
  };
};

export const getRecommendationsData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getRecommendationsData",
      payload: data,
    });
  };
};
export const updateKeytagsData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateKeytagsData",
      payload: data,
    });
  };
};

export const updateIsRelevanceTrendingData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateIsRelevanceTrendingData",
      payload: data,
    });
  };
};

export const updateTrendingIndex = (data) => {
  return (dispatch) => {
    dispatch({
      type: "updateTrendingIndex",
      payload: data,
    });
  };
};

export const getTabValue = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getTabValue",
      payload: data,
    });
  };
};

export const getTagsInOpen = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getKeyTagsDataOpen",
      payload: data,
    });
  };
};

export const briefSourceChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "briefSourceChange",
      payload: data,
    });
  };
};

export const briefLangChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "briefLangChange",
      payload: data,
    });
  };
};

export const briefQueryChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "briefQueryChange",
      payload: data,
    });
  };
};

export const briefPanningBreakdownChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "briefPanningBreakdownChange",
      payload: data,
    });
  };
};

export const newBriefChange = () => {
  return (dispatch) => {
    dispatch({
      type: "newBriefChange",
      payload: "",
    });
  };
};

export const briefRespChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "briefRespChange",
      payload: data,
    });
  };
};

export const briefisInputShowChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "briefisInputShowChange",
      payload: data,
    });
  };
};

export const briefIsLoadingChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "briefIsLoadingChange",
      payload: data,
    });
  };
};

export const briefAgenticIdChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "briefAgenticIdChange",
      payload: data,
    });
  };
};
export const getTagsInExpertOpen = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getkeytagsinexpertopen",
      payload: data,
    });
  };
};

export const getDataForExpertAnswersViewCount = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getDataForExpertAnswersViewStatistics",
      payload: data,
    });
  };
};
export const isExternalSearchAllowed = (data) => {
  return (dispatch) => {
    dispatch({
      type: "isExternalSearchAllowed",
      payload: data,
    });
  };
};

export const briefAgenticIsOpen = (data) => {
  return (dispatch) => {
    dispatch({
      type: "briefAgenticIsOpen",
      payload: data,
    });
  };
};

export const briefAgenticIsIframe = (data) => {
  return (dispatch) => {
    dispatch({
      type: "briefAgenticIsIframe",
      payload: data,
    });
  };
};

export const getScrollPositionInExpertOpen = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getscrollposition",
      payload: data,
    });
  };
};

export const briefAgentTargetUrlChange = (data) => {
  // console.log("data",data)
  return (dispatch) => {
    dispatch({
      type: "briefAgentTargetUrlChange",
      payload: data,
    });
  };
};
export const briefOutputChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "briefOutputChange",
      payload: data,
    });
  };
};

export const briefInternalSourceChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "briefInternalSourceChange",
      payload: data,
    });
  };
};
export const briefExternalSourceChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "briefExternalSourceChange",
      payload: data,
    });
  };
};

export const ET_UPDATE_TICKET_DATA = (data) => {
  return (dispatch) => {
    dispatch({
      type: "ET_UPDATE_TICKET_DATA",
      payload: data,
    });
  };
};

export const ET_UPDATE_TICKET_COUNT = (data) => {
  return (dispatch) => {
    dispatch({
      type: "ET_UPDATE_TICKET_COUNT",
      payload: data,
    });
  };
};

export const ET_UPDATE_IS_LOADING = (data) => {
  return (dispatch) => {
    dispatch({
      type: "ET_UPDATE_IS_LOADING",
      payload: data,
    });
  };
};

export const ET_UPDATE_PAGE_NO = (data) => {
  return (dispatch) => {
    dispatch({
      type: "ET_UPDATE_PAGE_NO",
      payload: data,
    });
  };
};

export const ET_UPDATE_SEARCH = (data) => {
  return (dispatch) => {
    dispatch({
      type: "ET_UPDATE_SEARCH",
      payload: data,
    });
  };
};

export const ET_UPDATE_REFRESH = () => {
  return (dispatch) => {
    dispatch({
      type: "ET_UPDATE_REFRESH",
      payload: "",
    });
  };
};

export const ET_UPDATE_SORT = (data) => {
  return (dispatch) => {
    dispatch({
      type: "ET_UPDATE_SORT",
      payload: data,
    });
  };
};

export const ET_UPDATE_Bulk_REFRESH = (data) => {
  return (dispatch) => {
    dispatch({
      type: "ET_UPDATE_Bulk_REFRESH",
      payload: data,
    });
  };
};

export const isUserLoggedInOrNot = (data) => {
  return (dispatch) => {
    dispatch({
      type: "isUserLoggedInOrNot",
      payload: data,
    });
  };
};

export const CheckEditAnswerBrief = (data) => {
  return (dispatch) => {
    dispatch({
      type: "checkEditedAnswer",
      payload: data,
    });
  };
};

export const ChangePublishButton = (data) => {
  return (dispatch) => {
    dispatch({
      type: "ChangePublishButton",
      payload: data,
    });
  };
};

export const getAgenticSourceData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "getAgenticSource",
      payload: data,
    });
  };
};

export const briefAttchmentChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "briefAttchmentChange",
      payload: data,
    });
  };
};
export const groupInfoBriefCountChanged = (data) => {
  return (dispatch) => {
    dispatch({
      type: "groupInfoBriefCountChanged",
      payload: data,
    });
  };
};

export const usedBriefCountChanged = (data) => {
  return (dispatch) => {
    dispatch({
      type: "usedBriefCountChanged",
      payload: data,
    });
  };
};

export const briefFromSeaerchChange = (data) => {
  return (dispatch) => {
    dispatch({
      type: "briefFromSeaerchChange",
      payload: data,
    });
  };
};
export const RefreshAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: "RefreshAction",
      payload: data,
    });
  };
};
export const zIndexFooterLoaderAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: "zIndexFooterLoaderAction",
      payload: data,
    });
  };
};

// RefreshAction
// zIndexFooterLoaderAction
